import { render, staticRenderFns } from "./waiting-approval.vue?vue&type=template&id=53f7992e&scoped=true"
import script from "./waiting-approval.vue?vue&type=script&lang=js"
export * from "./waiting-approval.vue?vue&type=script&lang=js"
import style0 from "./waiting-approval.vue?vue&type=style&index=0&id=53f7992e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f7992e",
  null
  
)

export default component.exports